import { useEffect, useState } from "react";
import useCart from "../hooks/useCart";
import { useTip } from "../hooks/useTip";
import {
    CheckCircleIcon,
    ChevronDownIcon,
    MinusCircleIcon,
    MinusIcon,
    PlusCircleIcon,
} from "@heroicons/react/24/outline";

const Cart = () => {
    const { cart: cartItems, onAddToCart, removeFromCart } = useCart();
    const [multibuy, setMultibuy] = useState(2.99);
    const [tipNumber] = useTip();
    const [service, setService] = useState(2.99);
    const [subTotal, setSubTotal] = useState(
        cartItems.reduce((accumulator, object) => {
            return accumulator + parseFloat(object.price) * object.qty;
        }, 0)
    );
    const mealOptions = ["Collection", "Delivery", "Eat In", "Takeaway"];
    const [selectedMealOption, setSelectedMealOption] = useState(mealOptions[0]);
    const [mealOptionMenu, setMealOptionMenu] = useState(false);
    const tableOptions = ["Table 1", "Table 2", "Table 3", "Table 4"];
    const [selectedTableOption, setSelectedTableOption] = useState(tableOptions[0]);
    const [tableOptionMenu, setTableOptionMenu] = useState(false);

    useEffect(() => {
        setSubTotal(
            cartItems.reduce((accumulator, object) => {
                return accumulator + parseFloat(object.price) * object.qty;
            }, 0)
        );
    }, [cartItems]);

    return (
        <>
            <div>
                <h2 className="w-full p-2 pb-0 font-semibold text-lg md:text-xl lg:text-2xl">Your Order</h2>
                <p className="text-shade-dark p-2 pt-1 text-sm font-light flex items-center">
                    <CheckCircleIcon className="w-4 h-4 mr-1" /> Ready to go
                </p>
                <div className="p-2 py-4">
                    <div className="flex w-full text-sm font-light">
                        <div
                            className={` ${
                                selectedMealOption === "Eat In" ? "w-1/2" : "w-full rounded"
                            } relative flex items-center justify-between select-none p-4 rounded-l cursor-pointer text-white bg-secondary`}
                            onClick={() => setMealOptionMenu(!mealOptionMenu)}
                        >
                            <ChevronDownIcon className="w-4 h-4" />
                            {selectedMealOption}
                            <div
                                className={`${
                                    mealOptionMenu ? "flex" : "hidden"
                                } absolute flex-col justify-center top-16 left-0 p-2 w-full rounded bg-secondary`}
                            >
                                {mealOptions.map((item, index) => (
                                    <div
                                        className="p-1 rounded hover:bg-primary hover:text-secondary w-full"
                                        onClick={() => setSelectedMealOption(item)}
                                        key={index}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div
                            className={`${
                                selectedMealOption === "Eat In" ? "flex" : "hidden"
                            } relative w-1/2 items-center justify-between select-none p-4 rounded-r cursor-pointer bg-shade`}
                            onClick={() => setTableOptionMenu(!tableOptionMenu)}
                        >
                            {selectedTableOption}
                            <ChevronDownIcon className="w-4 h-4" />
                            <div
                                className={`${
                                    tableOptionMenu ? "flex" : "hidden"
                                } absolute flex-col justify-center top-16 left-0 p-2 w-full rounded bg-secondary`}
                            >
                                {tableOptions.map((item, index) => (
                                    <div
                                        className="p-1 rounded text-white hover:bg-primary hover:text-secondary w-full"
                                        onClick={() => setSelectedTableOption(item)}
                                        key={index}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex-1 m-2 p-2 pr-4 py-6 border-y-[1.5px] border-shade-dark h-full overflow-y-scroll">
                {cartItems.length > 0 ? (
                    cartItems.map((item) => (
                        <div className="flex justify-between py-3" key={item.id}>
                            <div className="flex">
                                <div className="px-1 h-8 mr-2 flex justify-center items-center rounded-md bg-shade-light">
                                    <MinusCircleIcon
                                        onClick={() => removeFromCart(item.id)}
                                        className="cursor-pointer hover:text-primary w-5 md:w-4"
                                    />
                                    <p className="px-1 select-none">{item.qty}</p>
                                    <PlusCircleIcon
                                        onClick={() => (item.qty < 24 ? onAddToCart(item, 1) : null)}
                                        title={"£ " + item.price}
                                        className={`cursor-pointer ${
                                            item.qty < 24 ? "text-secondary hover:text-primary" : "text-shade-dark"
                                        } w-5 md:w-4`}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-sm font-light underline">{item.productName}</h2>
                                    {item.meal ? (
                                        <>
                                            <p className="text-xs text-gray-500 font-light">Make it A Meal</p>
                                            <p className="text-xs text-gray-500 font-light">{item.meal}</p>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                            <p className="text-sm font-light whitespace-nowrap">
                                £ {(parseFloat(item.price) * item.qty).toFixed(2)}
                            </p>
                        </div>
                    ))
                ) : (
                    <div className="text-shade-dark text-center text-sm">Your basket is empty</div>
                )}
            </div>
            <div className="p-2 text-sm font-light">
                {/* <span className="text-gray-400 flex justify-between">
                    <p>Multibuy discount</p>
                    <p>-£{multibuy}</p>
                </span> */}
                <span className="text-gray-400 flex justify-between">
                    <p>Subtotal</p>
                    <p>£{subTotal.toFixed(2)}</p>
                </span>
                {/* <span className="text-gray-400 flex justify-between">
                    <p>Service charge</p>
                    <p>£{service.toFixed(2)}</p>
                </span> */}
                <span className="text-gray-400 flex justify-between">
                    <p>Tip</p>
                    <p>£{parseFloat(tipNumber).toFixed(2)}</p>
                </span>
                <span className="flex justify-between">
                    <p>Total</p>
                    <p>£{(parseFloat(subTotal) + parseFloat(tipNumber) + service - multibuy).toFixed(2)}</p>
                </span>
            </div>
        </>
    );
};
export default Cart;
